"use client";

import ButtonV2 from "@/components/ButtonV2";
import Link from "next/link";
import React from "react";

const Hero = () => {
  return (
    <section className="flex flex-col items-center justify-center max-w-6xl 2xl:max-w-[1420px] mx-auto px-6 md:px-12 pt-24 pb-32 text-center">
      <h1 className="text-white font-bold text-[120px] sm:text-[180px] lg:text-[240px] leading-[0.8] mb-6">KOLZ</h1>

      <h2 className="text-white font-semibold text-2xl sm:text-3xl lg:text-[40px] leading-tight mb-4">
        AI-Powered Distribution for Web3
      </h2>

      <h3 className="text-white/90 font-normal text-lg sm:text-xl lg:text-[24px] leading-relaxed mb-12 max-w-4xl">
        Automated influence. Real KOLs. Zero manual effort. <br /> Maximum mindshare.
      </h3>

      <div className="mb-6">
        <ButtonV2 size="lg" color="secondary" href="/#sign-up-cta">
          Launch Campaign
        </ButtonV2>
      </div>

      <Link
        href="https://app.uniswap.org/explore/tokens/base/0x50ce4129ca261ccde4eb100c170843c2936bc11b"
        className="text-white/70 hover:text-white transition-colors duration-200 text-lg font-medium underline"
        target="_blank"
        rel="noreferrer noopener"
      >
        Powered by $KOLZ
      </Link>
    </section>
  );
};

export default Hero;
